module.exports = __webpack_public_path__ + "static/lincoln-in-the-bardo-e3005a3fb5065550e3ac33a4df19d64d.jpg";